export default __webpack_public_path__ + "images/TJ.4c7615b.png";